import { render, staticRenderFns } from "./statisReport.vue?vue&type=template&id=4cbf223d&scoped=true&"
import script from "./statisReport.vue?vue&type=script&lang=ts&"
export * from "./statisReport.vue?vue&type=script&lang=ts&"
import style0 from "./statisReport.vue?vue&type=style&index=0&id=4cbf223d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf223d",
  null
  
)

export default component.exports